export enum PaymentChannel {
  BKASH = 'BKASH',
  BANK_DEPOSIT = 'BANK_DEPOSIT',
  CASH_COUNTER = 'CASH_COUNTER',
  COMMISSION_WALLET = 'COMMISSION_WALLET',
}

export enum PaymentStatus {
  PENDING = 'PENDING',
  VERIFIED = 'VERIFIED',
  REJECTED = 'REJECTED',
}

export enum ReconciliationStatus {
  PENDING_AUDIT = 'PENDING_AUDIT',
  MATCHED = 'MATCHED',
  DISCREPANCY_FLAGGED = 'DISCREPANCY_FLAGGED',
  REJECTED = 'REJECTED',
}

export enum ClaimStatus {
  PENDING_VERIFICATION = 'PENDING_VERIFICATION', // backend OTP_PENDING
  PENDING_ADMIN = 'PENDING_ADMIN', // backend: OTP verified, awaiting staff processing (E15 result)
  AUTHORIZED = 'AUTHORIZED',
  DISBURSED = 'DISBURSED',
  REJECTED = 'REJECTED', // backend: staff rejected / cash claim cancelled; gross returned to balance
  EXPIRED = 'EXPIRED',
}

export enum DelinquencyStatus {
  ACTIVE = 'ACTIVE',
  DUE = 'DUE',
  IN_NOTICE_PERIOD = 'IN_NOTICE_PERIOD',
  INACTIVE = 'INACTIVE', // PRD v1.4.0 §1.3: Defaulted (60+ days overdue, read-only mode)
  CLOSED = 'CLOSED',     // PRD v1.4.0 §1.3: Permanently closed (terminal, cannot be reopened/transferred)
  DISABLED_DEFAULT = 'DISABLED_DEFAULT', // Legacy alias for INACTIVE
  SUSPENDED = 'SUSPENDED', // Staff-imposed: sign-in refused, money-out frozen (backend UserStatus.SUSPENDED)
}

/** Mirrors the backend wire enum (API_CONTRACT E08/E24) value for value — no translation layer. */
export enum InstallmentStatus {
  UPCOMING = 'UPCOMING', // future month, not yet billed
  DUE = 'DUE', // billed, awaiting payment
  PAID = 'PAID',
  ADVANCED = 'ADVANCED', // PRD v1.4.0 §3.1: Future months paid ahead (turns to PAID on 1st of month)
  IN_NOTICE_PERIOD = 'IN_NOTICE_PERIOD', // past due, inside the notice window
  DEFAULTED = 'DEFAULTED', // past the notice window
}

